<template>
  <div class="month-picker">
    <action
      class="month-picker__nav"
      color="secondary"
      :title="$t('previous')"
      square
      @click="slideLeft"
    >
      <icon type="chevron-left" />
    </action>

    <div class="month-picker__wrapper">
      <div class="month-picker__slide js-month-picker-slide">
        <div
          v-for="(months, year) in $store.state.eventsByType"
          :key="year"
          class="month-picker__row"
        >
          <strong class="month-picker__year">{{ year }}</strong>
          <action
            v-for="(days, month) in months"
            :key="month"
            :color="year + '-' + month === highlighted ? 'primary' : 'secondary'"
            class="month-picker__month"
            @click="emitDate(year + '-' + month)"
          >
            {{ monthName(month) }}
          </action>
        </div>
      </div>
    </div>

    <action
      class="month-picker__nav"
      color="secondary"
      :title="$t('next')"
      square
      @click="slideRight"
    >
      <icon type="chevron-right" />
    </action>
  </div>
</template>

<script>
import action from './action.vue'
import icon from './icon.vue'

import monthNames from '../functions/monthNames'

export default {
  name: 'CMonthPicker',

  components: {
    action,
    icon
  },

  props: {
    selected: {
      type: String,
      default: undefined
    }
  },

  emits: ['date'],

  data () {
    return {
      highlighted: this.selected
    }
  },

  computed: {
    slide () {
      return this.$el.querySelector('.js-month-picker-slide')
    }
  },

  methods: {
    slideLeft () {
      this.slide.scrollLeft = this.slide.scrollLeft - 100
    },
    slideRight () {
      this.slide.scrollLeft = this.slide.scrollLeft + 100
    },
    emitDate (date) {
      this.highlighted = date
      this.$emit('date', date)
    },
    formatMonth (month) {
      return month < 10 ? '0' + month : month
    },
    monthName (month) {
      return monthNames(this.$i18n.locale)[month - 1]
    }
  }
}
</script>

<i18n locale="en">
{
  "previous": "Previous",
  "next": "Next"
}
</i18n>

<i18n locale="de">
{
  "previous": "Zurück",
  "next": "Weiter"
}
</i18n>

<style lang="scss">
@import "../css/variables";

.month-picker {
  display: flex;
  align-items: center;
}

.month-picker__nav {
  display: none;
  flex-shrink: 0;

  @media (min-width: $breakpoint-md) {
    display: block;
  }
}

.month-picker__wrapper {
  position: relative;
  width: 0;
  flex-grow: 1;

  &::after {
    content: "";

    position: absolute;
    width: $gutter-sm;
    top: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(
      to right,
      rgb(255 255 255 / 0),
      #fff
    );
  }

  @media (min-width: $breakpoint-md) {
    margin: 0 $gutter-sm;
  }
}

.month-picker__slide {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;

  scroll-behavior: smooth;

  @media (min-width: $breakpoint-md) {
    overflow-x: hidden;
  }
}

.month-picker__row {
  display: flex;
  flex-shrink: 0;
  margin: $gutter-sm 0;
}

.month-picker__year {
  display: flex;
  flex-shrink: 0;
  position: sticky;
  align-items: center;
  left: 0;
  padding-right: $gutter-sm;

  background-image: linear-gradient(
    to right,
    #fff,
    #fff calc(100% - #{$gutter-sm}),
    rgb(255 255 255 / 0)
  );
}

.month-picker__month {
  flex-shrink: 0;
  margin-right: $gutter-sm;
}
</style>
